// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24rKU","questions":"styles_questions__2JGcA","footer":"styles_footer__1sH0q"};